<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      
      <div id="Titulo_div">
        <h1>Detalle De Dictamen</h1>
      </div>      
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area" v-if="dictamen != null">
            <div class="row">
              <div class="col-12">
                <h5> Datos del dictamen #{{dictamen.DictamenId}}</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-12"><hr /></div>
            </div>
            <div class="row">
              <div class="col-3 d-flex justify-content-start">
                <b>No. Expediente:</b>
                <span>{{dictamen.Expediente.Consecutivo}}</span>
              </div>
              <div class="col-3 d-flex justify-content-start">
                <b>Fecha límite de contestación:</b>
                <span>{{dictamen.FechaLimiteContestacionString}}</span>
              </div>

              <div class="col-3 d-flex justify-content-start">
                <b>Fecha de Rececpción (Oficio):</b>
                <span>{{dictamen.FechaDeRecepcionString}}</span>
              </div>
              <div class="col-3 d-flex justify-content-start">
                <b>Psicologo:</b>
                <span>{{dictamen.Psicologo.NombreCompleto}}</span>
              </div>
            </div>
            <div class="row new-row">
              <div class="col-3 d-flex justify-content-start">
                <b>Mayores evaluados:</b>
                <span>{{dictamen.NumeroDeAdultosEvaluados}}</span>
              </div>
              <div class="col-3 d-flex justify-content-start">
                <b>Menores evaluados:</b>
                <span>{{dictamen.NumeroDeMenoresEvaluados}}</span>
              </div>
            </div>
            <div class="row new-row d-flex justify-content-start">
              <div class="col-12">
                <b>Observaciones:</b>
                <span>{{dictamen.Observaciones}}</span>
              </div>
            </div>
            <div class="row new-row">
              <div class="col-12"><h5>Citas</h5></div>
            </div>
            <div class="row">
              <div class="col-12"><hr /></div>
            </div>
            <div class="row new-row">
              <table class="table table-striped table-light table-hover"
                     id="tablaCitas">
                <thead class="thead-dark">
                  <tr>
                    <th>No. Folio</th>
                    <th>Nombre del Evaluado</th>
                    <th>Menor de Edad</th>
                    <th>Fecha Programada</th>
                    <th>Estatus</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-for="cita in dictamen.CitasDeDictamen" v-bind:key="cita.CitaDeDictamenId">
                    <td>{{cita.CitaDeDictamenId}}</td>
                    <td>{{cita.PersonaEvaluada.Nombre}} {{cita.PersonaEvaluada.ApellidoPaterno}} {{cita.PersonaEvaluada.ApellidoMaterno}}</td>
                    <td><i class="fas fa-check" v-if="cita.PersonaEvaluada.EsMenor"></i> <i class="fas fa-times" v-else></i></td>
                    <td>{{cita.FechaCitaString}}</td>
                    <td>{{cita.EstatusCita.Nombre}}</td>
                    <td class="d-flex justify-content-around">
                      <!--<i class="fas fa-calendar fa-lg" @click="cambiarPestana(1, cita.CitaDeDictamenId)" title="Reagendar Cita" v-show="cita.EstatusCita.Nombre == 'Agendada'" />-->
                      <!--<i class="fas fa-check fa-lg" @click="mostrarModalFinalizarCita(cita.CitaDeDictamenId)" title="Concluir Dictamen" v-show="cita.EstatusCita.Nombre == 'Agendada' " />-->
                      <i class="fas fa-info-circle fa-lg" @click="irDetalleDeCita(cita.CitaDeDictamenId)" title="Detalle del Dictamen" />
                    </td>
                  </tr>
                  <tr v-if="dictamen.CitasDeDictamen.length == 0"><td colspan="6">No se encontraron citas en la búsqueda.</td></tr>

                </tbody>
              </table>
            </div>
            <div class="row new-row">
              <div class="col-11"></div>
              <div class="col-1">
                <router-link :to="{ name: 'ConsultaDeDictamenes'}">
                  <button class="form-control"><i class="fa fa-arrow-left"></i><span class="col-form-label" style="margin-left:5px">Regresar</span></button>
                  </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  export default {
    data() {
      return {
        dictamen: null
      }
    },
    props: {
      dictamenId: 0
    },
    components: {
      
    },
    methods: {
      getDictamen: function () {
        var peticion = {
          "esPrueba": false,
          "DictamenId": this.dictamenId
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.GetDictamen, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.dictamen = response.data.Dictamen
            this.$nextTick(() => {
              PaginarTabla('tablaCitas', 10)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      irDetalleDeCita: function (citaId) {
        //Redirigeal usuario a la pantalla de editarusuario mandando como parametro el id de persona a editar
        this.$router.push({
          name: "DetalleDeCitaDeDictamen",
          params: { citaId: citaId, dictamenId: this.dictamenId }
        });
      }
    }, mounted: function mounted() {
      if (this.dictamenId != 0)
      this.getDictamen();
    },
    computed: {
      
    }
  }
</script>

<style scoped>
  b {
    padding-right: 3px;
  }
  .new-row {
    margin-top: 20px;
  }
  .fas {
    cursor: pointer;
  }
</style>





// WEBPACK FOOTER //
// src/components/SIPSIC/Dictamenes/ConsultaDeDictamenes/DetalleDeDictamen.vue